import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  isNewPerDiem?: boolean
}

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export const TripInformationSchema = ({
  customizationFields,
  resourceType,
  isNewPerDiem,
}: FormContext) => {
  return z.object({
    from: z
      .string()
      .nullish()
      .refine(
        (from) =>
          isNewPerDiem
            ? true
            : isMandatory('from', resourceType, customizationFields)
              ? !!from
              : true,
        defaultRequiredMessage()
      ),
    to: z
      .string()
      .nullish()
      .refine(
        (to) =>
          isNewPerDiem
            ? true
            : isMandatory('to', resourceType, customizationFields)
              ? !!to
              : true,
        defaultRequiredMessage()
      ),
  })
}

export type TripInformationSchema = z.infer<ReturnType<typeof TripInformationSchema>>
